import {ErrorHandler, Injectable, Injector, NgZone, OnDestroy} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {DialogErrorComponent} from "../components/dialog-error/dialog-errorcomponent";
import {ADMINISTRATOR, isGalaxy, jsDateToEpoch, playSound, validateEmail} from "../common";
import {StoreSelectorsService} from "./store-selectors.service";
import {IUser} from "../interfaces";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler, OnDestroy {
    private opened;
    private storeSelector;
    private email = '';
    private sub;

    constructor(private zone: NgZone, private dialog: MatDialog, injector: Injector) {
        setTimeout(() => {
            this.storeSelector = injector.get(StoreSelectorsService);
            if (this.storeSelector) {
                this.sub = this.storeSelector.getUser()
                    .subscribe((user: IUser) => {
                        if (validateEmail(user.email)) {
                            this.email = user.email;
                            this.sub?.unsubscribe();
                        }
                    });
            }
        });
    }

    openDialog(i_err, status: number = 0): void {
        if (this.ignoreErrors(i_err)) return;
        const timeNow = jsDateToEpoch(new Date());
        const quietUntilStored = Number(window.localStorage.getItem('ignoreErrorsTimes'));
        if (timeNow < quietUntilStored)
            return;
        window.localStorage.setItem('ignoreErrorsTimes', String(0));
        if (!this.opened) {
            this.opened = true;
            const dialogRef = this.dialog.open(DialogErrorComponent, {
                data: {message: this.formatError(i_err), status},
                maxHeight: '100%',
                width: '540px',
                maxWidth: '100%',
                disableClose: true,
                hasBackdrop: true,
            });
            dialogRef.afterClosed().subscribe((v) => {
                this.opened = false;
                if (v === 'none') return;
                const timeNow2 = jsDateToEpoch(new Date());
                const quietUntil = timeNow2 + Number(v);
                window.localStorage.setItem('ignoreErrorsTimes', String(quietUntil));
            });
        }
    }

    handleError(error: any) {
        // Check if it's an error from an HTTP response
        // if (!(error instanceof HttpErrorResponse)) {
        //     error = error.rejection; // get the error object
        //     alert('http err ' + error);
        // }
        console.log(`%c Oops... something doesnt look right:  ${error}`, 'background: #222; color: #bada55');
        const m = error?.message || 'Oops! something doesnt look right';


        /** reload if chunk failed **/
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        if (chunkFailedMessage.test(m)) {
            if (confirm("Found new version of SignStudio, reload App?")) {
                window.location.reload();
            }
            return;
        }

        /** never open error dialog in galaxy but do send email to administrator if error is a non-ignored error **/

        if (window.location.href.indexOf('konenoot') > -1) {
            return;
        }
        if (isGalaxy()) {
            if (this.ignoreErrors(error)) return;
            try {
                if (error?.stack) {
                    error = error.stack;
                } else {
                    error = error?.message || 'Undefined client error';
                }
            } catch (e) {
                error = 'tried to parse object but was not successful';
            }
            const message = `error: global handler ${error}`;
            this.storeSelector.sendEmail(ADMINISTRATOR, `${m} | ${message}`, this.email, true);
            return;
        } else {
            this.openError(error);
        }
    }

    formatError(i_error): string {
        let error = i_error;
        if (i_error === null) {
            return 'defined as null error';
        }
        if (i_error?.message) {
            error = 'messageError: ' + i_error.message;
        }
        if (i_error?.stack) {
            error = error + ' stackError: ' + i_error.stack;
        }
        if (i_error?.message === null && i_error?.stack === null) {
            error = 'error: ' + i_error;
        }
        return error.toLowerCase();
    }

    ignoreErrors(i_err): boolean {
        const message = this.formatError(i_err);
        if (message.indexOf("idpiframe_initialization_failed") > -1) return true;
        if (message.indexOf("google") > -1) return true;
        if (message.indexOf("fromentries") > -1) return true;
        if (message.indexOf("playerservice") > -1) return true;
        if (message.indexOf("unknownerror") > -1) return true;
        if (message.indexOf("cookies") > -1) return true;
        if (message.indexOf("was interrupted") > -1) return true;
        if (message.indexOf("operation was aborted") > -1) return true;
        if (message.indexOf("uncacheapp") > -1) return true;
        if (message.indexOf("duotone") > -1) return true;
        if (message.indexOf("webgl unsupported") > -1) return true;
        if (message.indexOf("message exists in error") > -1) return true;
        if (message.indexOf("Oops!") > -1) return true;
        if (message.indexOf("undefined client error") > -1) return true;
        if (message.indexOf("requested device not found") > -1) return true;
        if (message.indexOf(`"status":false`) > -1) return true;
        if (message.indexOf("media was removed") > -1) return true;
        if (message.indexOf("marketing@clearview.crs") > -1) return true;
        // if (message.indexOf("convertKeyframes") > -1) return true;
        // if (message.indexOf(`expressionchangedafterithasbeencheckederror`) > -1) return true;
        return false;
    }

    openError(error) {
        playSound('error');
        const m = error?.message || 'Undefined client error';
        this.zone.run(() => {
            this.openDialog(error);
        });
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub?.unsubscribe();
        }
    }
}

// {
//     provide: HTTP_INTERCEPTORS,
//     useClass: HttpLoadingInterceptor,
//     multi: true
// },
// @Injectable()
// export class HttpLoadingInterceptor implements HttpInterceptor {
//     constructor() {
//     }
//
//     intercept(
//         request: HttpRequest<any>,
//         next: HttpHandler
//     ): Observable<HttpEvent<any>> {
//         // this.loadingDialogService.openDialog();
//         return next.handle(request).pipe(
//             finalize(() => {
//                 // this.loadingDialogService.hideDialog();
//             })
//         ) as Observable<HttpEvent<any>>;
//     }
// }
//
// detect if dev tools is open or not
// private devtools = {
//     isOpen: false,
//     orientation: undefined,
// };
// initListenDevTools() {
//     this.zone.runOutsideAngular(() => {
//         const threshold = 5;
//         const emitEvent = (isOpen, orientation) => {
//             globalThis.dispatchEvent(new globalThis.CustomEvent('devtoolschange', {
//                 detail: {
//                     isOpen,
//                     orientation,
//                 },
//             }));
//         };
//         const main = ({emitEvents = true} = {}) => {
//             const widthThreshold = globalThis.outerWidth - globalThis.innerWidth > threshold;
//             const heightThreshold = globalThis.outerHeight - globalThis.innerHeight > threshold;
//             const orientation = widthThreshold ? 'vertical' : 'horizontal';
//
//             if (
//                 !(heightThreshold && widthThreshold)
//                 && ((globalThis.Firebug && globalThis.Firebug.chrome && globalThis.Firebug.chrome.isInitialized) || widthThreshold || heightThreshold)
//             ) {
//                 if ((!this.devtools.isOpen || this.devtools.orientation !== orientation) && emitEvents) {
//                     emitEvent(true, orientation);
//                 }
//
//                 this.devtools.isOpen = true;
//                 this.devtools.orientation = orientation;
//             } else {
//                 if (this.devtools.isOpen && emitEvents) {
//                     emitEvent(false, undefined);
//                 }
//
//                 this.devtools.isOpen = false;
//                 this.devtools.orientation = undefined;
//             }
//         };
//
//         main({emitEvents: false});
//         setInterval(main, 2000);
//
//         window.addEventListener('devtoolschange', (event: any) => {
//             console.log('Is DevTools open:', event.detail.isOpen);
//             console.log('DevTools orientation:', event.detail.orientation);
//         });
//     });
// }
